export default __webpack_public_path__ + "static/media/maestro.bca14f07.svg";